import React from 'react';

import { createStackNavigator } from '@react-navigation/stack';

import WelcomeScreen from '../screens/welcome/WelcomeScreen';
import WelcomeSurveyScreen from '../screens/welcome/WelcomeSurveyScreen';
import { getScreenOptions } from './getScreenOptions';
import AppHeader from '../components/AppHeader';

export type WelcomeNavigatorParamList = {
  Welcome: undefined;
  WelcomeSurvey:
    | {
        path?: string;
        sectionIndex?: number;
        history?: string; // stringified array
      }
    | undefined;
};

const WelcomeStack = createStackNavigator<WelcomeNavigatorParamList>();

export default function WelcomeNavigator() {
  return (
    <WelcomeStack.Navigator
      initialRouteName='Welcome'
      screenOptions={({ route }) => ({
        headerShown: false,
        ...getScreenOptions(route),
        gestureEnabled: false
      })}
    >
      <WelcomeStack.Screen name='Welcome' component={WelcomeScreen} />
      <WelcomeStack.Screen
        options={{
          headerShown: true,
          header: () => <AppHeader disableNavigation />
        }}
        name='WelcomeSurvey'
        component={WelcomeSurveyScreen}
      />
    </WelcomeStack.Navigator>
  );
}
